<template>
   <div class="optionitem" 
      @mouseover="hovered = true"
      @mouseleave="hovered = false"
      :class="{'active': active}">
        <img :src="image" v-show="active || hovered"> 
        <img :src="imageblack" v-show="!active && !hovered">
        <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
  props:["text","image","active","imageblack"],
  name: "SmallOption",
  data(){
    return {
      hovered: false
    }
  }
}
</script>

<style scoped>
.optionitem{
  display: inline-flex;
  justify-items: center;
  flex-direction: row;
  align-items: center;
  color:#5C5E60;
}

.optionitem.active{
  color:#2650e7;
}

.optionitem:hover{
  background-color: rgb(240,240,240);
}

img{
  width: 50px;
}

.optionitem:hover{
  cursor: pointer;
}

p{
  margin-bottom: 0;
  margin-top: 10px;
  font-family: "Montserrat";
  font-size: 20px;
}
</style>